import { z } from 'zod';

import { Expression } from '../../Expressions/ExpressionEvaluator';

/**
 * Simple task creation config
 *
 * - when the step activates, create a task
 * - when the step skips or fails, archive the task
 * - when the step completes, complete the task
 */
export type SimpleCreateTaskOnExpression = z.infer<typeof SimpleCreateTaskOnExpression>;
export const SimpleCreateTaskOnExpression = z.object({
  type: z.literal('simpleCreateTaskOnExpression'),
  expression: Expression('boolean'),
});

// we'll probably want more complex configs in future, using something we can
// union-ify later for futureproofing
export type CreateTask = z.infer<typeof CreateTask>;
export const CreateTask = SimpleCreateTaskOnExpression;
